import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ADSENSE } from "@/config/monetization";
import Home from "@/pages/Home";
import ArticlePage from "@/pages/ArticlePage";
import Sobre from "@/pages/Sobre";
import Contato from "@/pages/Contato";
import Privacidade from "@/pages/Privacidade";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ArticleEditor from "@/pages/admin/ArticleEditor";
import Calculadora from "@/pages/Calculadora";
import CategoryPage from "@/pages/CategoryPage";

const RedirectHandler = () => {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    useEffect(() => {
        const r = params.get("r");
        if (r && r.startsWith("/")) navigate(r, { replace: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

// O script do AdSense é carregado estaticamente no <head> do index.html
// (exigência de verificação do Google). As unidades manuais (AdSlot.jsx)
// são ativadas quando os slots forem configurados no .env.

function App() {
    return (
        <div className="App">
            <div className="grain-overlay" />
            <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
                <BrowserRouter>
                    <ScrollToTop />
                    <RedirectHandler />
                    <Navbar />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/artigo/:slug" element={<ArticlePage />} />
                        <Route path="/categoria/:slug" element={<CategoryPage />} />
                        <Route path="/sobre" element={<Sobre />} />
                        <Route path="/contato" element={<Contato />} />
                        <Route path="/privacidade" element={<Privacidade />} />
                        <Route path="/calculadora" element={<Calculadora />} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<AdminDashboard />} />
                        <Route path="/admin/artigo/novo" element={<ArticleEditor />} />
                        <Route path="/admin/artigo/:id/editar" element={<ArticleEditor />} />
                    </Routes>
                    <Footer />
                    <Toaster position="bottom-right" theme="dark" />
                </BrowserRouter>
            </ReactLenis>
        </div>
    );
}

export default App;
